// Main entry point for webpack bundle
import icons from "./svg/index.js";
import "./ss-icon.js";
import "./ss-loader.js";
import "./style.css";

// Export icons for library usage
export { icons };
export default { icons };
